import BaseModel from './BaseModel';
export default class Category extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.name = data.name || this.translate.name || undefined;
        this.createdDate = data.createdDate || undefined
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                categoryId: this.translate.categoryId || this.id,
                name: this.name,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}
